// test1762
(1762 && 0);
